// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root___1rdH","signatureBlock":"Footer_signatureBlock__1JTQT","signature":"Footer_signature__Bowus"};